import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import {
  withRouter,
  RouteComponentProps,
  generatePath,
} from "react-router-dom";
import Page from "components/Layout/Page/Page";
import LayoutContainer from "components/Layout/Container";
import Header from "components/Layout/Header/Header";
import PublishButton from "components/PublishButton/PublishButton";
import { BackButtonWrapper, Container } from "./styles";
import AddEditForm from "./AddEditForm/AddEditForm";
import ROUTES from "navigation/routes";
import withGlobalPopup, {
  GlobalPopupProps,
} from "components/Popup/withGlobalPopup";
import {
  withGlobalSnackbar,
  SnackbarContextProps,
} from "services/snackbar/snackbarContext";
import { SNACKBAR_TYPES } from "components/Snackbar/Snackbar";
import CollectionStore from "stores/CollectionStore";
import { observer } from "mobx-react-lite";

type RouteParams = {
  id?: string;
};

type AddEditProps = GlobalPopupProps &
  SnackbarContextProps &
  RouteComponentProps<RouteParams>;

const AddEdit: React.FC<AddEditProps> = ({
  history,
  match,
  location,
  setMessage,
}) => {
  const [wantsGoBack, setWantsGoBack] = useState<boolean>(false);
  const locationState = location.state;
  const isEditMode = locationState?.editMode;

  const { id } = match?.params;
  const isNewItem = !id;
  const loadCollection = async () => {
    if (!id) return;
    try {
      const collectionId = parseInt(id);
      await CollectionStore.getCollection(collectionId);
    } catch (error) {
      setMessage(
        error?.message || "Failed to get collection details",
        SNACKBAR_TYPES.ERROR,
      );
    }
  };

  useEffect(() => {
    loadCollection();
  }, []);

  const onBackClick = () => {
    const path = generatePath(ROUTES.CONTENT_CONTENT_COLLECTIONS);
    history.push({ pathname: path, state: { editMode: false } });
  };

  return (
    <LayoutContainer header={<Header controls={<PublishButton />} />}>
      <Page
        isLoading={CollectionStore.isCollectionsLoading}
        title="Special Program Detail"
        topControls={
          <BackButtonWrapper>
            <Button
              color="secondary"
              variant="text"
              startIcon={<KeyboardBackspaceIcon />}
              onClick={() => setWantsGoBack(true)}
            >
              Back to Special Programs
            </Button>
          </BackButtonWrapper>
        }
      >
        <Container>
          <AddEditForm
            initialValues={
              isNewItem ? undefined : CollectionStore.selectedCollection
            }
            isEditMode={isEditMode}
            isNewItem={isNewItem}
            onBack={onBackClick}
            wantsGoBack={wantsGoBack}
          />
        </Container>
      </Page>
    </LayoutContainer>
  );
};

export default withGlobalPopup(
  withGlobalSnackbar(withRouter(observer(AddEdit))),
);
